import AnimatedContent from '@/components/AnimatedContent.jsx';
import { HotspotOverlay } from './HotspotOverlay.jsx';

/**
 * @param {{
 *   visible: boolean;
 *   exiting: boolean;
 *   animationKey: number;
 *   fontEpoch?: number;
 *   payload: { markerName: string; driver: import('../drivers.js').Driver; description: string; cornerKey: string } | null;
 *   onExitComplete: () => void;
 * }} props
 */
export function HotspotOverlayApp({
  visible,
  exiting,
  animationKey,
  fontEpoch = 0,
  payload,
  onExitComplete,
}) {
  if ((!visible && !exiting) || !payload) return null;

  const { markerName, driver, description, cornerKey } = payload;

  return (
    <div className="hotspot-overlay" aria-live="polite">
      <AnimatedContent
        key={`${cornerKey}-${animationKey}-${fontEpoch}`}
        triggerOnMount
        isExiting={exiting}
        onExitComplete={onExitComplete}
        direction="horizontal"
        reverse
        distance={48}
        duration={0.65}
        ease="power3.out"
        exitEase="power3.in"
        initialOpacity={0}
        animateOpacity
        className="hotspot-overlay__anim"
      >
        <HotspotOverlay
          markerName={markerName}
          driver={driver}
          description={description}
        />
      </AnimatedContent>
    </div>
  );
}
